export enum AboutRoutes {
  Contact = 'contact',
  AboutUs = 'us',
  Gdpr = 'gdpr',
  Terms = 'terms',
  Legal = 'legal',
  Explanation = 'blockchain-notary',
}
